import React from 'react';
import cx from './index.module.scss';

const DownloadButton = () => {
  return (
    <a className={cx.wrap} href="https://go.onelink.me/VCvk/blindindex">
      <img className={cx.logo} src={`${process.env.PUBLIC_URL}/images/icon_logo@2x.png`} alt=""/>
    </a>
  )
};

export default DownloadButton;
